module.exports = __webpack_public_path__ + "static/media/coffee.f29d4f35.svg";